import {mediaMatch} from "../../../../utils";

const isMdmax = mediaMatch.isMdmax;

const initialState = {
  loading: false,
  orderList: [],
  query: {
    page: 1,
    limit: isMdmax ? 5 : 10,
  },
  total: 0,
  tabActive: false,
  commentVisible: false,
  commentGoodsDetail: {},
  statusTabs: [
    {
      label: '全部',
      value: false,
    },
    {
      label: '待付款',
      value: '0',
    },
    {
      label: '待发货',
      value: '2',
    },
    {
      label: '待收货',
      value: '3',
    },
    {
      label: '已完成',
      value: '1',
    }
  ]
};

function reducer(state, action) {
  switch (action.type) {
    case 'setLoading':
      return { ...state, loading: action.payload };
    case 'setOrderList':
      return { ...state, orderList: action.payload };
    case 'setTotal':
      return { ...state, total: action.payload };
    case 'setTabActive':
      return { ...state, tabActive: action.payload };
    case 'setQuery':
      return { ...state, query: action.payload };
    case 'setCommentVisible':
      return { ...state, commentVisible: action.payload };
    case 'setCommentGoodsDetail':
      return { ...state, commentGoodsDetail: action.payload };
    default:
  }
}

const setCommentGoodsDetail = payload => ({
  type: 'setCommentGoodsDetail',
  payload,
});

const setCommentVisible = payload => ({
  type: 'setCommentVisible',
  payload,
});

const setLoading = payload => ({
  type: 'setLoading',
  payload,
});

const setTotal = payload => ({
  type: 'setTotal',
  payload,
});

const setOrderList = payload => ({
  type: 'setOrderList',
  payload,
});

const setTabActive = payload => ({
  type: 'setTabActive',
  payload,
});

const setQuery = payload => ({
  type: 'setQuery',
  payload,
});

export {
  initialState,
  reducer,
  setTotal,
  setLoading,
  setOrderList,
  setTabActive,
  setQuery,
  setCommentVisible,
  setCommentGoodsDetail
};
